<template>
	<Autocomplete
		v-model="selected"
		create
		display-name="Notizarten"
		:icon="icon"
		:label="t('component.notes.noteType', multiple ? 2 : 1)"
		name="notetype"
		:multiple="multiple"
		endpoint="notestype"
		item-title="name"
		v-bind="$attrs"
		:params="{ of: 'name', od: 'ASC' }"
		data-test="notestype-autocomplete"
		@created="created"
	>
	</Autocomplete>
</template>

<script setup lang="ts">
import { useNoteTypeStore } from '@/stores/modules/noteType'
import Autocomplete from '../Validation/Autocomplete.vue'
import { useI18n } from 'vue-i18n'

defineProps({
	icon: {
		default: 'fa-regular fa-sticky-note',
		type: String,
	},
	multiple: {
		default: false,
		type: Boolean,
	},
})

const { t } = useI18n()

const selected = defineModel()

const { create } = useNoteTypeStore()

function created(value) {
	create({ data: { name: value } }).then((notestype) => {
		selected.value = notestype
	})
}
</script>

<style scoped></style>
